import React, { Component } from 'react'
import './Search.css'
import Form from '../../common/formComponents/Form'
import AutoCompleter from '../../common/formComponents/AutoCompleter'
import withPolyglot from '../../common/withPolyglot'

// const pathologies = [
//   'Hep. B',
//   'Hib',
//   'Difteria',
//   'Tétano',
//   'Tétano',
//   'Tosse Convulsa',
//   'Poliomielite',
//   'Doença Pneumocócica',
//   'Doença Meningocócica C',
//   'Sarampo'
// ]

// const PathList = (props) => <li>{props.value}</li>

class Search extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selected: undefined
    }
    this.getElementFromName = this.getElementFromName.bind(this)
    this.getButtonsForDocs = this.getButtonsForDocs.bind(this)
  }

  getOptions (docs) {
    return docs.map(element => {
      return {
        displayValue: element.name,
        key: element.name
      }
    })
  }

  getButtonsForDocs (element) {
    const { translate } = this.props
    return element.docs.map(doc => {
      return <a href={doc.url} target='_blank' rel='noopener noreferrer' key={doc.name}>
        <button className='uk-button uk-margin-small-top uk-button-primary uk-align-center' style={{color: 'white'}}>
          {translate(doc.name, true, 'documentType')}
        </button>
      </a>
    })
  }

  getElementFromName (element) {
    return this.props.docs.find(doc => doc.name === element)
  }

  render () {
    return (
      <div className='search-container uk-container uk-container-small uk-margin-medium-top'>
        <Form type={'horizontal'} handleSubmit={() => {}}>
          <AutoCompleter
            autoFocus
            name={'pathologiesSelect'}
            onSuggestionSelected={(element) => { this.setState({selected: this.getElementFromName(element.suggestionValue.key)}) }}
            options={this.getOptions(this.props.docs)}
            minChar={2} />
        </Form>
        {this.state.selected
          ? <div>
            <h3>
              {this.state.selected && this.state.selected.name}
              <div className='uk-float-left clickable'>
                <span data-uk-icon='chevron-left' onClick={() => this.setState({selected: undefined})} />
              </div>
            </h3>
            <div className='uk-margin-medium-right'>
              {this.getButtonsForDocs(this.state.selected)}
            </div>
          </div>
          : <div data-uk-grid className='uk-grid uk-child-width-1-2'>
            <div>
              <h4>Patologias</h4>
              {this.props.docs.map(doc => doc.type === 'pathology' ? <li key={doc.name} className='uk-list clickable' onClick={() => this.setState({selected: this.getElementFromName(doc.name)})}>{doc.name}</li> : null)}
            </div>
            <div>
              <h4>Medicamentos</h4>
              {this.props.docs.map(doc => doc.type === 'vaccine' ? <li key={doc.name} className='uk-list clickable' onClick={() => this.setState({selected: this.getElementFromName(doc.name)})}>{doc.name}</li> : null)}
            </div>
          </div>
        }
      </div>
    )
  }
}

export default withPolyglot(Search)
